module.exports = __webpack_public_path__ + "img/order-pending.0a71beb6.gif";